import { useEffect, useState } from "react";

const ScrollHint = ({
  children,
  hintPosition = "right",
  hintIcon,
  className = "",
  scrollRef,
  containerRef,
}) => {
  const [showScrollHint, setShowScrollHint] = useState(false);

  useEffect(() => {
    const scrollTarget = scrollRef?.current;
    if (!scrollTarget) return;

    const checkOverflow = () => {
      const hasOverflow = scrollTarget.scrollWidth > scrollTarget.clientWidth;
      setShowScrollHint(hasOverflow);
    };

    checkOverflow();

    const handleScroll = () => {
      setShowScrollHint(false);
    };

    scrollTarget.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", checkOverflow);

    return () => {
      scrollTarget.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [scrollRef]);

  return (
    <div className={`relative w-full ${className}`}>
      {showScrollHint && (
        <div
          className={`absolute flex z-50 top-2 animate-pulse pointer-events-none text-sm text-gray-500 ${
            hintPosition === "right" ? "right-2" : "left-2"
          }`}
        >
          {hintIcon} Deslize
        </div>
      )}
      <div
        className="w-full"
        style={{
          overflowX: "auto",
          overflowY: "visible",
          position: "relative",
        }}
        ref={containerRef}
      >
        {children}
      </div>
    </div>
  );
};

export default ScrollHint;
